import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  brands: null,
  loading: false,
  brandBtnLoading: false,
  deleteBtnLoading: false,
  brandProducts:[],
  loadMore:false,
  leadsexhausted: false,
  lastDoc: null,
  limit: 8,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.BRANDS_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
